import { render, staticRenderFns } from "./BoxStoreRank.vue?vue&type=template&id=54c574b2&scoped=true&"
import script from "./BoxStoreRank.vue?vue&type=script&lang=ts&"
export * from "./BoxStoreRank.vue?vue&type=script&lang=ts&"
import style0 from "./BoxStoreRank.vue?vue&type=style&index=0&id=54c574b2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c574b2",
  null
  
)

/* custom blocks */
import block0 from "./BoxStoreRank.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxStoreRank.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QSelect,QSeparator,QBtnToggle,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QSelect,QSeparator,QBtnToggle,QTable,QTd})
